(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lown-ba"] && !Shopify.designMode) return;
  try {
    
  function lbaLigar(el){
    var faixa = el.querySelector('[data-lba-range]');
    if (!faixa) return;
    var aplicar = function(){ el.style.setProperty('--lba-pos', faixa.value + '%'); };
    faixa.addEventListener('input', aplicar);
    aplicar();
  }
  document.querySelectorAll('[data-lba]').forEach(lbaLigar);
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('[data-lba]').forEach(lbaLigar);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-cart-drawer"]) return;
  try {
    
  (function () {
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var caixa = document.querySelector('[data-cart-dialog]');
    if (!caixa) return;

    var lista = caixa.querySelector('[data-cart-content]');
    var aviso = caixa.querySelector('[data-cart-status]');
    var rodape = caixa.querySelector('[data-cart-footer]');
    var d = caixa.dataset;
    var limite = parseInt(d.limite || '0', 10);
    var relogio = null;

    var formato = d.formato || '{{amount}}';
    function dinheiro(centavos) {
      var valor = (centavos / 100);
      return formato.replace(/\{\{\s*(\w+)\s*\}\}/g, function (todo, chave) {
        var casas = chave.indexOf('no_decimals') > -1 ? 0 : 2;
        var virgula = chave.indexOf('comma_separator') > -1;
        var n = valor.toFixed(casas);
        var partes = n.split('.');
        var inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, virgula ? '.' : ',');
        if (casas === 0) return inteiro;
        return inteiro + (virgula ? ',' : '.') + partes[1];
      });
    }
    function cria(tag, texto, classe) {
      var n = document.createElement(tag);
      if (texto !== undefined && texto !== null) n.textContent = texto;
      if (classe) n.className = classe;
      return n;
    }
    function svg(d, preenche) {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('viewBox', '0 0 24 24');
      s.setAttribute('aria-hidden', 'true');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', d);
      s.appendChild(p);
      s.style.fill = preenche || 'none';
      s.style.stroke = preenche ? 'none' : 'currentColor';
      s.style.strokeWidth = '1.8';
      s.style.strokeLinecap = 'round';
      s.style.strokeLinejoin = 'round';
      return s;
    }

    function frete(carrinho) {
      var cx = caixa.querySelector('[data-ship]');
      if (!cx || !limite) return;
      cx.hidden = carrinho.item_count === 0;
      var texto = cx.querySelector('[data-ship-text]');
      var barra = cx.querySelector('[data-ship-bar]');
      var falta = limite - carrinho.total_price;
      texto.replaceChildren();
      if (falta > 0) {
        cx.classList.remove('is-free');
        texto.appendChild(svg('M3 7h11v9H3zM14 10h4l3 3v3h-7z'));
        texto.appendChild(document.createTextNode(
          d.tFehlt.replace('{betrag}', dinheiro(falta))));
        barra.style.width = Math.max(3, carrinho.total_price / limite * 100) + '%';
      } else {
        cx.classList.add('is-free');
        var ok = svg('M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17m-4 8.9 2.6 2.6L16 9.6');
        ok.style.stroke = '#2bb24c';
        texto.appendChild(ok);
        texto.appendChild(document.createTextNode(d.tFrei));
        barra.style.width = '100%';
      }
    }

    function reserva(carrinho) {
      var cx = caixa.querySelector('[data-reserve]');
      if (!cx) return;
      var minutos = parseInt(d.reserva || '0', 10);
      if (!minutos || !carrinho.item_count) { cx.hidden = true; clearInterval(relogio); return; }
      cx.hidden = false;
      if (relogio) return;
      var resta = minutos * 60;
      var pintar = function () {
        var m = Math.floor(resta / 60), s = resta % 60;
        cx.textContent = d.tReserviert.replace('{zeit}', m + ':' + (s < 10 ? '0' : '') + s);
        if (resta <= 0) { clearInterval(relogio); relogio = null; cx.hidden = true; return; }
        resta--;
      };
      pintar();
      relogio = setInterval(pintar, 1000);
    }

    function linha(item, carrinho) {
      var row = cria('div', undefined, 'cd-line');

      var media = cria('a', undefined, 'cd-line-media');
      media.href = item.url;
      if (item.image) {
        var img = cria('img');
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
        img.alt = item.product_title;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      row.appendChild(media);

      var info = cria('div');
      var nome = cria('a', item.product_title, 'cd-line-name');
      nome.href = item.url;
      info.appendChild(nome);

      var precos = cria('p', undefined, 'cd-line-prices');
      if (item.original_price > item.final_price) {
        precos.appendChild(cria('s', dinheiro(item.original_price)));
      }
      precos.appendChild(cria('b', dinheiro(item.final_price)));
      if (item.original_price > item.final_price) {
        var economia = (item.original_price - item.final_price) * item.quantity;
        precos.appendChild(cria('span',
          d.tSparen + ' ' + dinheiro(economia), 'cd-save'));
      }
      info.appendChild(precos);

      if (item.variant_title) info.appendChild(cria('p', item.variant_title, 'cd-line-variant'));

      (item.line_level_discount_allocations || []).forEach(function (dd) {
        if (!dd.amount) return;
        var tag = cria('span', undefined, 'cd-tag');
        tag.appendChild(svg('M3 11.5 11.5 3H21v9.5L12.5 21z'));
        tag.appendChild(document.createTextNode(
          dd.discount_application.title + ' (−' + dinheiro(dd.amount) + ')'));
        info.appendChild(tag);
      });
      row.appendChild(info);

      var lado = cria('div', undefined, 'cd-line-side');
      var campo = cria('input', undefined, 'cd-qty');
      campo.type = 'number';
      campo.min = '0';
      campo.step = '1';
      campo.value = item.quantity;
      campo.dataset.lineKey = item.key;
      campo.setAttribute('aria-label', d.tMenge + ' — ' + item.product_title);
      var tirar = cria('button', d.tEntfernen, 'cd-remove');
      tirar.type = 'button';
      tirar.dataset.removeKey = item.key;
      lado.appendChild(campo);
      lado.appendChild(tirar);
      row.appendChild(lado);
      return row;
    }

    function pintar(carrinho) {
      lista.replaceChildren();
      document.querySelectorAll('[data-cart-count]').forEach(function (e) {
        e.textContent = carrinho.item_count;
      });
      var selo = caixa.querySelector('[data-cart-count-badge]');
      if (selo) selo.textContent = carrinho.item_count;

      if (!carrinho.items.length) {
        lista.appendChild(cria('p', d.tLeer, 'cd-empty'));
      } else {
        carrinho.items.forEach(function (item) { lista.appendChild(linha(item, carrinho)); });
      }

      frete(carrinho);
      reserva(carrinho);

      rodape.hidden = !carrinho.items.length;
      var upsell = caixa.querySelector('[data-cd-upsell]');
      if (upsell) {
        upsell.hidden = !carrinho.items.length;
        var dentro = carrinho.items.map(function (i) { return String(i.variant_id); });
        upsell.querySelectorAll('[data-up-id]').forEach(function (c) {
          c.hidden = dentro.indexOf(c.dataset.upId) > -1;
        });
        setaEstado();
      }

      var economia = carrinho.original_total_price - carrinho.total_price;
      var cxSub = caixa.querySelector('[data-cd-sub]');
      if (cxSub) {
        cxSub.hidden = economia <= 0;
        cxSub.querySelector('[data-sub-value]').textContent =
          dinheiro(carrinho.original_total_price);
      }
      var cxEcon = caixa.querySelector('[data-cd-savings]');
      if (cxEcon) {
        cxEcon.hidden = economia <= 0;
        cxEcon.querySelector('[data-savings-label]').textContent = d.tErsparnis;
        cxEcon.querySelector('[data-savings-value]').textContent =
          '−' + dinheiro(economia);
      }
      caixa.querySelector('[data-total-label]').textContent = d.tGesamt;
      caixa.querySelector('[data-cart-subtotal]').textContent =
        dinheiro(carrinho.total_price);
    }

    function buscar() {
      return fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw Error('…'); return r.json(); });
    }
    function abrir() {
      aviso.textContent = '';
      if (!caixa.open) caixa.showModal();
      return buscar().then(pintar).catch(function (e) { aviso.textContent = e.message; });
    }
    function mudar(id, quantidade) {
      aviso.textContent = '';
      lista.inert = true;
      return fetch(raiz + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantidade })
      }).then(function (r) { return r.json(); })
        .then(pintar)
        .catch(function (e) { aviso.textContent = e.message; })
        .then(function () { lista.inert = false; });
    }

    function setaEstado() {
      var trilho = caixa.querySelector('[data-up-track]');
      if (!trilho) return;
      var pre = caixa.querySelector('[data-up-prev]'), pro = caixa.querySelector('[data-up-next]');
      if (pre) pre.disabled = trilho.scrollLeft <= 2;
      if (pro) pro.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2;
    }
    var trilho = caixa.querySelector('[data-up-track]');
    if (trilho) {
      trilho.addEventListener('scroll', setaEstado, { passive: true });
      var passo = function () {
        var c = trilho.querySelector('.cd-up:not([hidden])');
        return c ? c.getBoundingClientRect().width + 12 : 240;
      };
      caixa.querySelector('[data-up-prev]').addEventListener('click', function () {
        trilho.scrollBy({ left: -passo(), behavior: 'smooth' });
      });
      caixa.querySelector('[data-up-next]').addEventListener('click', function () {
        trilho.scrollBy({ left: passo(), behavior: 'smooth' });
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); abrir(); }
      if (e.target.closest('[data-cart-close]')) caixa.close();
      if (e.target === caixa) caixa.close();

      var tirar = e.target.closest('[data-remove-key]');
      if (tirar) mudar(tirar.dataset.removeKey, 0);

      var add = e.target.closest('[data-up-add]');
      if (add) {
        add.disabled = true;
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(add.dataset.upAdd), quantity: 1 }] })
        }).then(function () { return buscar(); })
          .then(pintar)
          .catch(function () {})
          .then(function () { add.disabled = false; });
      }
    });

    caixa.addEventListener('change', function (e) {
      if (e.target.matches('[data-line-key]')) {
        mudar(e.target.dataset.lineKey, Number(e.target.value));
      }
    });

    caixa.querySelector('[data-drawer-checkout]').addEventListener('click', function () {
      var form = document.createElement('form');
      form.method = 'post';
      form.action = raiz + 'cart';
      var campo = document.createElement('input');
      campo.type = 'hidden';
      campo.name = 'checkout';
      campo.value = 'Checkout';
      form.appendChild(campo);
      document.body.appendChild(form);
      form.submit();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-product-form]')) return;
      if (form.querySelector('[data-bundles] input[name=lp-bundle]:checked')) return;
      e.preventDefault();
      var botao = form.querySelector('[data-add-button]');
      var msg = form.querySelector('[data-form-message]');
      if (botao) botao.disabled = true;
      if (msg) msg.textContent = '';
      fetch(raiz + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
      }).then(function (r) { return r.json(); })
        .then(function () { return abrir(); })
        .catch(function (erro) { if (msg) msg.textContent = erro.message; })
        .then(function () { if (botao) botao.disabled = false; });
    });

    document.addEventListener('lown:cart:refresh', function () { abrir(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-header"]) return;
  try {
    

  document.addEventListener('click',e=>{const dialog=document.querySelector('[data-menu-dialog]');if(e.target.closest('[data-menu-open]'))dialog?.showModal();if(e.target.closest('[data-menu-close]'))dialog?.close();if(e.target===dialog)dialog.close()});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-loved"] && !Shopify.designMode) return;
  try {
    
  function llLigar(sec) {
    var trilho = sec.querySelector('[data-ll-track]');
    if (!trilho) return;
    var pontos = sec.querySelector('[data-ll-dots]');
    var pre = sec.querySelector('[data-ll-prev]');
    var pro = sec.querySelector('[data-ll-next]');
    var cards = trilho.children;
    if (!cards.length) return;

    if (pontos && !pontos.children.length) {
      for (var i = 0; i < cards.length; i++) pontos.appendChild(document.createElement('i'));
    }
    var passo = function () {
      return cards[0].getBoundingClientRect().width +
        parseFloat(getComputedStyle(trilho).columnGap || 16);
    };
    var estado = function () {
      var meio = trilho.scrollLeft + trilho.clientWidth / 2;
      var atual = 0, menor = Infinity;
      for (var k = 0; k < trilho.children.length; k++) {
        var filho = trilho.children[k];
        var centro = filho.offsetLeft - trilho.offsetLeft + filho.offsetWidth / 2;
        var dist = Math.abs(centro - meio);
        if (dist < menor) { menor = dist; atual = k; }
      }
      if (trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2) {
        atual = trilho.children.length - 1;
      }
      if (trilho.scrollLeft <= 2) atual = 0;
      if (pontos) {
        for (var i = 0; i < pontos.children.length; i++) {
          pontos.children[i].classList.toggle('is-on', i === atual);
        }
      }
      if (pre) pre.disabled = trilho.scrollLeft <= 2;
      if (pro) pro.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2;
    };
    if (pre) pre.addEventListener('click', function () {
      trilho.scrollBy({ left: -passo(), behavior: 'smooth' });
    });
    if (pro) pro.addEventListener('click', function () {
      trilho.scrollBy({ left: passo(), behavior: 'smooth' });
    });
    trilho.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado, { passive: true });
    estado();
  }
  document.querySelectorAll('[data-ll]').forEach(llLigar);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ll]').forEach(llLigar);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-marquee"] && !Shopify.designMode) return;
  try {
    
  function lmLigar(sec) {
    var trilho = sec.querySelector('[data-lm-track]');
    var base = trilho && trilho.querySelector('[data-lm-group]');
    if (!trilho || !base) return;

    // remove clones de uma montagem anterior
    while (trilho.children.length > 1) trilho.removeChild(trilho.lastElementChild);
    trilho.classList.remove('is-ready');

    var largura = base.getBoundingClientRect().width;
    if (!largura) return;

    // clona ate cobrir a tela com folga: o deslocamento e exatamente uma copia,
    // entao a emenda fica invisivel e nunca sobra vao
    var precisa = sec.getBoundingClientRect().width + largura;
    var copias = Math.max(2, Math.ceil(precisa / largura));
    for (var i = 1; i < copias; i++) {
      var clone = base.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-lm-group');
      trilho.appendChild(clone);
    }

    // velocidade constante: a duracao acompanha a largura de uma copia
    var segundos = parseFloat(sec.dataset.lmSpeed || '26');
    var base1000 = 1000;
    trilho.style.setProperty('--lm-shift', largura + 'px');
    trilho.style.setProperty('--lm-dur', (segundos * largura / base1000).toFixed(2) + 's');
    trilho.classList.add('is-ready');
  }

  function lmTodos() { document.querySelectorAll('[data-lm]').forEach(lmLigar); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(lmTodos);
  lmTodos();
  var lmTimer;
  window.addEventListener('resize', function () {
    clearTimeout(lmTimer);
    lmTimer = setTimeout(lmTodos, 180);
  }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lm]').forEach(lmLigar);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-product"] && !Shopify.designMode) return;
  try {
    
  function lpUpsellNav(sec){
    const track=sec.querySelector('[data-upsell-track]');if(!track)return;
    const prev=sec.querySelector('[data-upsell-prev]'),next=sec.querySelector('[data-upsell-next]');
    const passo=function(){const c=track.querySelector('.lp-up-card');
      return c?c.getBoundingClientRect().width+12:180;};
    const estado=function(){
      if(prev)prev.disabled=track.scrollLeft<=2;
      if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-passo(),behavior:'smooth'})});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:passo(),behavior:'smooth'})});
    track.addEventListener('scroll',estado,{passive:true});estado();
  }
  document.querySelectorAll('[data-upsell]').forEach(lpUpsellNav);
  document.addEventListener('shopify:section:load',function(e){
    e.target.querySelectorAll('[data-upsell]').forEach(lpUpsellNav);});
  document.addEventListener('click',function(e){
    const b=e.target.closest('[data-upsell-add]');if(!b)return;
    const id=Number(b.dataset.upsellAdd);const antes=b.textContent;
    b.disabled=true;b.textContent='\u2026';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){
        if(!r.ok)return r.text().then(function(t){throw new Error(t)});
        // abre a gaveta; se ela nao existir na pagina, cai para o carrinho
        var gaveta=document.querySelector('[data-cart-dialog]');
        if(gaveta){document.dispatchEvent(new CustomEvent('lown:cart:refresh'));}
        else{location.href='/cart';}
      })
      .catch(function(){b.textContent=antes;b.disabled=false;});
  });
  function lpMarcarMini(section, idx){
    section.querySelectorAll('.pg-thumb').forEach(function(t){
      var on = t.dataset.pgThumb === String(idx);
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on);
      if (on) t.scrollIntoView({block:'nearest', inline:'nearest', behavior:'smooth'});
    });
  }
  function lpMostrarMidia(section, mediaId){
    var alvo = section.querySelector('#Media-' + mediaId);
    if (!alvo) return;
    var trilho = section.querySelector('.pg-main');
    if (!trilho) return;
    trilho.scrollTo({ left: alvo.offsetLeft - trilho.offsetLeft, behavior: 'smooth' });
    lpMarcarMini(section, alvo.dataset.pgSlide);
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('.pg-thumb');
    if (!t) return;
    lpMostrarMidia(t.closest('[data-product-section]'), t.dataset.mediaId);
  });
  // ao deslizar, a miniatura ativa acompanha
  function lpSeguirRolagem(trilho){
    if (trilho.dataset.lpTrack) return;
    trilho.dataset.lpTrack = '1';
    var agendado = false;
    trilho.addEventListener('scroll', function(){
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function(){
        agendado = false;
        var meio = trilho.scrollLeft + trilho.clientWidth / 2;
        var melhor = null, menor = Infinity;
        [].forEach.call(trilho.children, function(f){
          var centro = f.offsetLeft - trilho.offsetLeft + f.offsetWidth / 2;
          var d = Math.abs(centro - meio);
          if (d < menor) { menor = d; melhor = f; }
        });
        if (melhor) lpMarcarMini(trilho.closest('[data-product-section]'), melhor.dataset.pgSlide);
      });
    }, {passive:true});
  }
  document.querySelectorAll('.pg-main').forEach(lpSeguirRolagem);
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('.pg-main').forEach(lpSeguirRolagem);
  });
  function lpMoeda(cents){
    const v=(cents/100).toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.');
    return '€'+v;
  }
  function lpVarianteAtiva(section){
    return section.querySelector('[data-variant-cards] input[name=id]:checked')
        || section.querySelector('input[name=id]');
  }
  function lpRecalcular(section){
    const v=lpVarianteAtiva(section);if(!v)return;
    const base=parseInt(v.dataset.cents||'0',10);
    const baseCmp=parseInt(v.dataset.compareCents||v.dataset.cents||'0',10);
    const sel=section.querySelector('[data-bundles] input[name=lp-bundle]:checked');
    let qty=1,extra=0,extraCmp=0;
    if(sel){qty=parseInt(sel.dataset.qtyMain||'1',10);
      extra=parseInt(sel.dataset.extraTotal||'0',10);
      extraCmp=parseInt(sel.dataset.extraCompare||'0',10);}
    const total=base*qty+extra, cmp=baseCmp*qty+extraCmp;
    section.querySelectorAll('[data-bundles] .lp-bundle').forEach(function(l){
      const inp=l.querySelector('input'),q=parseInt(inp.dataset.qtyMain||'1',10);
      const t=base*q+parseInt(inp.dataset.extraTotal||'0',10);
      const c=baseCmp*q+parseInt(inp.dataset.extraCompare||'0',10);
      const p=l.querySelector('[data-bundle-price]');if(p)p.textContent=lpMoeda(t);
      const ml=l.querySelector('[data-main-line-price]');
      if(ml)ml.innerHTML=(baseCmp>base?'<s>'+lpMoeda(baseCmp*q)+'</s>':'')+lpMoeda(base*q);
      const tot=l.querySelector('[data-bundle-total]');if(tot)tot.textContent=lpMoeda(t);
      const was=l.querySelector('[data-bundle-was]');if(was)was.textContent=c>t?lpMoeda(c):'';
      const bg=l.querySelector('[data-bundle-badge]');
      if(bg&&bg.dataset.tpl&&bg.dataset.tpl.indexOf('{ersparnis}')>-1){
        bg.textContent=c>t?bg.dataset.tpl.replace('{ersparnis}',lpMoeda(c-t)):bg.dataset.tpl.replace(/\s*\|?[^|]*\{ersparnis\}[^|]*/,'');
      }
      const sv=l.querySelector('[data-bundle-save]');
      if(sv){if(c>t){sv.textContent=Math.round((c-t)/c*100)+'% sparen · '+lpMoeda(c-t);sv.style.display='';}
             else{sv.style.display='none';}}
      const nv=l.querySelector('[data-main-variant]');
      if(nv){const rot=v.closest('.lp-variant');
        const txt=rot?(rot.querySelector('.lp-variant-name')||{}).childNodes:null;
        nv.textContent=rot?rot.querySelector('.lp-variant-name').firstChild.textContent.trim():'';}
      const th=l.querySelector('[data-main-thumb] img');
      if(th&&v.dataset.thumb)th.src=v.dataset.thumb;
    });
    const pr=section.querySelector('[data-atc-price]');if(pr)pr.textContent=lpMoeda(total);
    const wa=section.querySelector('[data-atc-was]');if(wa)wa.textContent=cmp>total?lpMoeda(cmp):'';
    const sp=document.querySelector('[data-sticky-price]');if(sp)sp.textContent=lpMoeda(total);
    const sw=document.querySelector('[data-sticky-was]');if(sw)sw.textContent=cmp>total?lpMoeda(cmp):'';
    const stt=document.querySelector('[data-sticky-thumb] img');
    if(stt&&v.dataset.thumb)stt.src=v.dataset.thumb;
    const qf=section.querySelector('input[name=quantity]');if(qf)qf.value=qty;
  }
  document.addEventListener('change',function(e){
    if(!e.target.matches('[data-bundles] input[name=lp-bundle]'))return;
    const section=e.target.closest('[data-product-section]');
    section.querySelectorAll('.lp-bundle').forEach(function(l){
      l.classList.toggle('is-selected',l.contains(e.target));});
    lpRecalcular(section);
  });
  document.addEventListener('submit',function(e){
    const form=e.target.closest('[data-product-form]');if(!form)return;
    const section=form.closest('[data-product-section]');
    const sel=section.querySelector('[data-bundles] input[name=lp-bundle]:checked');
    if(!sel||!sel.dataset.extras)return;
    e.preventDefault();
    const v=lpVarianteAtiva(section);
    const itens=[{id:Number(v.value),quantity:parseInt(sel.dataset.qtyMain||'1',10)}];
    sel.dataset.extras.split(',').filter(Boolean).forEach(function(par){
      const d=par.split(':');itens.push({id:Number(d[0]),quantity:Number(d[1])||1});});
    const btn=section.querySelector('[data-add-button]');btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:itens})})
      .then(function(r){
        if(!r.ok)return r.text().then(function(t){throw new Error(t)});
        // abre a gaveta; se ela nao existir na pagina, cai para o carrinho
        var gaveta=document.querySelector('[data-cart-dialog]');
        if(gaveta){document.dispatchEvent(new CustomEvent('lown:cart:refresh'));}
        else{location.href='/cart';}
      })
      .catch(function(err){const m=section.querySelector('[data-form-message]');
        if(m)m.textContent=String(err).slice(0,180);})
      .then(function(){btn.disabled=false;});
  });
  function lpAplicarVariante(input){
    const section=input.closest('[data-product-section]');if(!section)return;
    section.querySelectorAll('.lp-variant').forEach(l=>l.classList.toggle('is-selected',l.contains(input)));
    const atual=section.querySelector('[data-variant-current]');if(atual)atual.textContent=input.dataset.title;
    const button=section.querySelector('[data-add-button]');
    button.disabled=input.dataset.available!=='true';
    button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.label;
    const sticky=document.querySelector('[data-sticky-add]');
    if(sticky){sticky.disabled=button.disabled;sticky.textContent=button.textContent;document.querySelector('[data-sticky-price]').textContent=input.dataset.price}
    const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
    if(input.dataset.media)lpMostrarMidia(section,input.dataset.media);
    lpRecalcular(section);
  }
  document.addEventListener('change',e=>{if(e.target.matches('[data-variant-cards] input[name=id]'))lpAplicarVariante(e.target)});
  document.addEventListener('click',e=>{if(e.target.closest('[data-sticky-add]'))document.querySelector('[data-product-form]')?.requestSubmit()});
  function observeProduct(){
    const bloco=document.querySelector('.product-layout'),
          sticky=document.querySelector('[data-product-sticky]');
    if(!bloco||!sticky)return;
    let agendado=false;
    const avaliar=function(){
      agendado=false;
      const b=bloco.getBoundingClientRect();
      const passou=b.bottom<0;
      let colide=false;
      const pe=document.querySelector('footer,.site-footer');
      if(pe){const f=pe.getBoundingClientRect();colide=f.top<window.innerHeight-10;}
      sticky.hidden=!passou||colide;
    };
    const agendar=function(){if(agendado)return;agendado=true;requestAnimationFrame(avaliar);};
    window.addEventListener('scroll',agendar,{passive:true});
    window.addEventListener('resize',agendar,{passive:true});
    avaliar();
  }

  observeProduct();document.addEventListener('shopify:section:load',observeProduct);
  document.querySelectorAll('[data-product-section]').forEach(lpRecalcular);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-reviews"] && !Shopify.designMode) return;
  try {
    
  function lwLigar(sec) {
    var trilho = sec.querySelector('[data-lw-track]');
    if (!trilho || !trilho.children.length) return;
    var pontos = sec.querySelector('[data-lw-dots]');
    var pre = sec.querySelector('[data-lw-prev]');
    var pro = sec.querySelector('[data-lw-next]');
    if (pontos && !pontos.children.length) {
      for (var i = 0; i < trilho.children.length; i++) pontos.appendChild(document.createElement('i'));
    }
    var passo = function () {
      return trilho.children[0].getBoundingClientRect().width +
        parseFloat(getComputedStyle(trilho).columnGap || 16);
    };
    var estado = function () {
      var meio = trilho.scrollLeft + trilho.clientWidth / 2;
      var atual = 0, menor = Infinity;
      for (var k = 0; k < trilho.children.length; k++) {
        var filho = trilho.children[k];
        var centro = filho.offsetLeft - trilho.offsetLeft + filho.offsetWidth / 2;
        var dist = Math.abs(centro - meio);
        if (dist < menor) { menor = dist; atual = k; }
      }
      if (trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2) {
        atual = trilho.children.length - 1;
      }
      if (trilho.scrollLeft <= 2) atual = 0;
      if (pontos) for (var i = 0; i < pontos.children.length; i++) {
        pontos.children[i].classList.toggle('is-on', i === atual);
      }
      if (pre) pre.disabled = trilho.scrollLeft <= 2;
      if (pro) pro.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2;
    };
    if (pre) pre.addEventListener('click', function () { trilho.scrollBy({ left: -passo(), behavior: 'smooth' }); });
    if (pro) pro.addEventListener('click', function () { trilho.scrollBy({ left: passo(), behavior: 'smooth' }); });
    trilho.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado, { passive: true });
    estado();
  }
  document.querySelectorAll('[data-lw]').forEach(lwLigar);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lw]').forEach(lwLigar);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-upsell"] && !Shopify.designMode) return;
  try {
    
  function lpUpsellNav(sec){
    const track=sec.querySelector('[data-upsell-track]');if(!track)return;
    const prev=sec.querySelector('[data-upsell-prev]'),next=sec.querySelector('[data-upsell-next]');
    const passo=()=>{const c=track.querySelector('.lp-up-card');
      return c?c.getBoundingClientRect().width+16:260;};
    const estado=()=>{
      if(prev)prev.disabled=track.scrollLeft<=2;
      if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
    prev&&prev.addEventListener('click',()=>track.scrollBy({left:-passo(),behavior:'smooth'}));
    next&&next.addEventListener('click',()=>track.scrollBy({left:passo(),behavior:'smooth'}));
    track.addEventListener('scroll',estado,{passive:true});estado();
  }
  document.querySelectorAll('[data-upsell]').forEach(lpUpsellNav);
  document.addEventListener('shopify:section:load',e=>{
    e.target.querySelectorAll('[data-upsell]').forEach(lpUpsellNav);});

  document.addEventListener('click',function(e){
    const b=e.target.closest('[data-upsell-add]');if(!b)return;
    const id=Number(b.dataset.upsellAdd);b.disabled=true;
    const antes=b.textContent;b.textContent='…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){if(!r.ok)return r.text().then(function(t){throw new Error(t)});
        document.dispatchEvent(new CustomEvent('lown:cart:refresh'));location.href='/cart';})
      .catch(function(){b.textContent=antes;b.disabled=false;});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lown-videos"] && !Shopify.designMode) return;
  try {
    
  function lvLigar(sec) {
    var trilho = sec.querySelector('[data-lv-track]');
    if (!trilho || !trilho.children.length) return;
    var pontos = sec.querySelector('[data-lv-dots]');
    var pre = sec.querySelector('[data-lv-prev]');
    var pro = sec.querySelector('[data-lv-next]');
    if (pontos && !pontos.children.length) {
      for (var i = 0; i < trilho.children.length; i++) pontos.appendChild(document.createElement('i'));
    }
    var passo = function () {
      return trilho.children[0].getBoundingClientRect().width +
        parseFloat(getComputedStyle(trilho).columnGap || 16);
    };
    var estado = function () {
      var meio = trilho.scrollLeft + trilho.clientWidth / 2;
      var atual = 0, menor = Infinity;
      for (var k = 0; k < trilho.children.length; k++) {
        var filho = trilho.children[k];
        var centro = filho.offsetLeft - trilho.offsetLeft + filho.offsetWidth / 2;
        var dist = Math.abs(centro - meio);
        if (dist < menor) { menor = dist; atual = k; }
      }
      if (trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2) {
        atual = trilho.children.length - 1;
      }
      if (trilho.scrollLeft <= 2) atual = 0;
      if (pontos) for (var i = 0; i < pontos.children.length; i++) {
        pontos.children[i].classList.toggle('is-on', i === atual);
      }
      if (pre) pre.disabled = trilho.scrollLeft <= 2;
      if (pro) pro.disabled = trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 2;
    };
    if (pre) pre.addEventListener('click', function () { trilho.scrollBy({ left: -passo(), behavior: 'smooth' }); });
    if (pro) pro.addEventListener('click', function () { trilho.scrollBy({ left: passo(), behavior: 'smooth' }); });
    trilho.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado, { passive: true });
    estado();
  }
  document.querySelectorAll('[data-lv]').forEach(lvLigar);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lv]').forEach(lvLigar);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.lv-play');
    if (!b || b.disabled) return;
    var v = b.closest('[data-lv-media]').querySelector('video');
    if (v) { v.play(); b.remove(); }
  });

  } catch(e) { console.error(e); }
})();
})();
